module.exports = __webpack_public_path__ + "static/media/buy_start_service_make_1.75ac5b6f.jpg";